<template>
  <div class="success">
    <Poptip placement="bottom" content="content">
      <a class="success-num" @click="getPolicy" v-if="row.successNum > 0">{{ row.successNum }}</a>
      <div slot="content">
        <div class="policy-list-box">
          <span class="title">共 {{ list.length }} 份保单</span>
          <div class="list" v-for="(item, index) in list" :key="index">
            <span class="state" :class="item.status=='1'?'no-red':'red'"></span>
            <span class="policy-label">保单号：</span>
            <a class="policy-number" @click="openDetail({orgName:row.organizationName, groupName:row.groupName, salesmanName:row.agentName, ...item})">{{ item.policyNo }}</a>
          </div>
        </div>
      </div>
    </Poptip>
    <span v-if="row.successNum == 0">{{ row.successNum }}</span>

    <!-- 线上保单详情  -->
    <detailModal ref="detailModal"></detailModal>

    <!-- 线下保单详情 -->
    <policyDetail ref="policyDetailRef"></policyDetail>

  </div>
</template>

<script>
import detailModal from "../../../orderManage/insuredOrder/components/detailModal";
import policyDetail from "../../../orderManage/insuredOrder/components/policyDetail";
export default {
  props: ["row"],
  components:{
    detailModal,
    policyDetail
  },
  data() {
    return {
      list:[]
    };
  },

  methods:{
    getPolicy() {
      let userType = JSON.parse(localStorage.getItem('userInfo')).userType
      let data = {
        customerId:this.row.id,
        agentId:this.row.agentId,
      }
      if(userType!='4'){
        data.orgId = this.row.organizationId
      }
      this.$http({
        url: "/buz/customerBase/policyInfo",
        type: "POST",
        data
      }).then((res) => {
        this.list = res.data;
      })
    },

    openDetail(item) {
      if(item.sourceType==1){
        this.$refs.detailModal.open(item);
      }else{
        this.$refs.policyDetailRef.open(item);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.success {
  display: flex;
  justify-content: center;
  .success-num {
    text-align: center;
    border-bottom: 1px solid #2d8cf0;
  }
  .policy-list-box {
    padding: 13px 15px;
    display: flex;
    flex-direction: column;
    .title {
      text-align: left;
      font-size: 12px;
      color: #3c464f;
      margin-bottom: 5px;
    }
    .list {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      .state {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        margin-right: 6px;
      }
      & .red {
        background-color: #e3461f;
      }
      & .no-red {
        background-color: #35bf3f;
      }
      .policy-label {
        color: #515c6f;
        font-size: 12px;
      }
      .policy-number {
        color: #2d8cf0;
        font-size: 12px;
        margin-left: 8px;
        border-bottom: 1px solid #2d8cf0;
      }
    }
  }
}
</style>